import { render, staticRenderFns } from "./exportjr5.vue?vue&type=template&id=4b106f4c"
import script from "./exportjr5.vue?vue&type=script&lang=js"
export * from "./exportjr5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports